import VueFacebookPixel from 'vue-facebook-pixel'

const FB_PIXEL_CODE = '205918600215318'

export default async ({ router, Vue }) => {
  Vue.use(VueFacebookPixel)
  !process.env.DEV && Vue.analytics.fbq.init(FB_PIXEL_CODE)
}
